import CarCalculator from './components/CarCalculator';

function getShareToken() {
  const params = new URLSearchParams(window.location.search);
  return params.get('s');
}

export default function App() {
  const shareToken = getShareToken();
  return <CarCalculator initialShareToken={shareToken} />;
}
